import { COMMON } from "../../../util/localizations";

const TRANSLATIONS = {
    en: {
        amount: COMMON.en.amount,
        makeAnOffer: COMMON.en.makeOffer,
        noData: 'This token has never been traded.',
        title: COMMON.en.tokenHistory,
        transaction: 'Transaction',
        subtitle: `Trade history for token, "{0}".`
    }
}

export default TRANSLATIONS